import { provideZoneChangeDetection } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "@m19-board/app.component";
import { appConfig } from "@m19-board/app.config";

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => {
  // eslint-disable-next-line no-console
  console.error(err);
});
